module.exports = __webpack_public_path__ + "static/media/ico_radio.bf4807f2.svg";